import React, {ReactElement} from 'react';
import {useUIStore} from 'store/UI';
import {Keyboard} from 'components/Keyboard';
import {Animate} from 'components/Animate';

export const KeyboardView = (): ReactElement => {
  const {keyboardVisible} = useUIStore();

  return (
    <Animate mount={keyboardVisible}>
      <Keyboard />
    </Animate>
  );
};
